<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->

    <transition name="fade" appear>
      <div class="coming-soon" @click="animate">
        <h1 ref="hk" @mouseover="animate">Coming Soon...</h1>
      </div>
    </transition>
    <div class="loading_gif">
      <img src="@/assets/loader.gif" />
    </div>

    <nav id="header">
      <div class="uk-container uk-navbar" uk-navbar>
        <div class="uk-navbar-left">
          <a href="#" class="uk-navbar-item uk-logo uk-padding-remove-left">
            <img src="@/assets/logo-white-new.png" width="170" />
          </a>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav social_list">
            <a
              href="https://f-qr.github.io/bb/PPT%2015%20Aug%20How%20to%20Start%20A%20Start%20Up%20Event.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Download Brochure</button>
            </a>
            <a
              href="https://www.badabusiness.com/dd/BIMK003866"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Register For The Event</button>
            </a>
          </ul>
        </div>
      </div>
    </nav>

    <router-view />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Home",
    titleTemplate: "%s | Bada Business Assistant",
  },
  mounted() {
    var el = this.$refs.hk;
    el.innerHTML = el.textContent
      .split("")
      .map((e) => "<span>" + e + "</span>")
      .join("");

    this.animate();
  },
  methods: {
    animate() {
      var el = this.$refs.hk;

      var spans = el.getElementsByTagName("span");
      var i = 0;
      var f = () => {
        if (i < spans.length + 5) {
          setTimeout(f, 50);
        }
        if (i < spans.length) {
          spans[i].style.opacity = 0.4;
        }
        if (i >= 6) {
          spans[i - 6].style.opacity = 1;
        }
        i++;
      };

      setTimeout(f, 50);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/css2.css";
@import "./assets/styles/intlTelInput.css";
@import "./assets/styles/override.css";
@import "./assets/styles/uikit.css";

button {
  border-radius: 10px;
  padding: 5px 10px;
  font-weight: bold;
  margin: 5px;
}

button:hover {
  cursor: pointer;
}
.coming-soon {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  z-index: -1;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.coming-soon span {
  transition: all 0.25s;
}
.fade-enter-active {
  transition: all 500;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-to {
  opacity: 0.8;
}
.coming-soon > h1 {
  color: white;
  font-weight: bold;
  font-size: 500%;
  font-family: cursive;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  background: url("https://images.unsplash.com/photo-1517336714731-489689fd1ca8?ixlib=rb-1.2.1&auto=format&fit=crop&w=926&q=80")
    no-repeat;
  background-size: cover;
  min-width: 100px;
  // position: fixed;
  // overflow: auto;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
}

html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
